import React, { createContext, useContext, useState, ReactNode } from 'react';

interface DragContextType {
  isDragging: boolean;
  setIsDragging: (isDragging: boolean) => void;
}

const DragContext = createContext<DragContextType | undefined>(undefined);

export const useDragContext = () => {
  const context = useContext(DragContext);
  if (!context) {
    throw new Error('useDragContext must be used within a DragProvider');
  }
  return context;
};

interface DragProviderProps {
  children: ReactNode;
}

export const DragProvider: React.FC<DragProviderProps> = ({ children }) => {
  const [isDragging, setIsDragging] = useState(false);

  return (
    <DragContext.Provider value={{ isDragging, setIsDragging }}>
      {children}
    </DragContext.Provider>
  );
};

// Optional hook that returns null if no provider exists
export const useOptionalDragContext = (): DragContextType | null => {
  const context = useContext(DragContext);
  return context || null;
}; 